var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"c-infinity-tab__header"},[_vm._v(" You have "),_c('span',{staticClass:"c-infinity-tab__infinity-points"},[_vm._v(_vm._s(_vm.format(_vm.infinityPoints, 2)))]),_vm._v(" "+_vm._s(_vm.pluralize("Infinity Point", _vm.infinityPoints))+". ")])
}
var staticRenderFns = []

export { render, staticRenderFns }